<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f6xicZ/image/cover.jpg?1706480827478" alt="This image is the cover for the book How to Appear Normal at Social Events"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Appear Normal at Social Events
      </h1>
      <p class="bookDescription body article font2">
        <i>How to Appear Normal at Social Events </i>is an oddly cheering book of illustrated lists. Largely based on Lord Birthday's popular Instagram account, the book offers excessively absurd, occasionally wise advice on topics ranging from finding your life's purpose to defending yourself against forest clowns. (Hint: Set an oatmeal trap.)<br/> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lord Birthday
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17a3c195